import { Checkbox, FormControlLabel } from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";

type SelecionarAlternativaProps = {
  handleSelect: () => void,
  value: string,
  checked: boolean
}

export default function SeletorAlternativa({ handleSelect, value, checked }:SelecionarAlternativaProps){
  return (
    <FormControlLabel
      value={value}
      control={
        <Checkbox
          onClick={handleSelect}
          icon={ <RadioButtonUncheckedIcon /> }
          checkedIcon={ <RadioButtonCheckedIcon /> }
          checked={checked}
        />
      }
      label=""
      labelPlacement="end"
    />)
}